import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        gap: theme.spacing(1),
    },
}));

export const NotTemplatesItems = () => {
    const { t } = useTranslation();
    const classes = useStyles();
    return (
        <Box className={classes.root}>
            <img src="/static/images/no_data.svg" width="40%" />
            <Typography
                variant="body1"
                color={'textPrimary'}
                style={{
                    fontWeight: 'bold',
                    fontSize: 20,
                    marginBottom: 0,
                }}
            >
                {t('TemplatesTwilio.NoTemplates')}
            </Typography>
        </Box>
    );
};
